import { GEOMETRYTYPE } from "../featuretree/internal";
import { MEASUREMODE } from "../internal";
import { USERINPUTTYPE } from "../userinput/internal";
import { Tool } from "./internal";
/**
 * Draw Point Tool
 * @class DrawPointTool
 * @extends {Tool}
 */
export class DrawPointTool extends Tool {
    constructor(scene, toolhandler, options, name, group) {
        super(scene, toolhandler);
        // event variables
        this.mouseupeventnr = null;
        this.mousemoveeventnr = null;
        this.mouseouteventnr = null;
        this.resetinputevent = null;
        this.finishinputevent = null;
        this.resetinputtevent = null;
        this.holdeventnr = null;
        this.releaseeventnr = null;
        this.drageventnr = null;
        this.doubletapeventnr = null;
        this.snap_mx = null;
        this.snap_my = null;
        this.snappedpos = null;
        this.featurecollection = null;
        this.pointfeature = null;
        this.contpointfeature = null;
        this.pos = null;
        this.evt = null;
        this.pointpending = false;
        this.name = name;
        this.group = group;
        super.parseOptions(options);
        this.featurecollection = this.scene
            .getFeatureHandler()
            .createFeatureCollection(this.options.layerstyle, this.options.highlightlayerstyle, "mmDrawingToolPointCollection_internal", false);
        this.type = "DrawPointTool";
        this.pointfeature = this.featurecollection.createFeature();
        this.pointfeature.geometry = this.pointfeature.createGeometry(GEOMETRYTYPE.POINT);
        if (this.options.continousdraw) {
            this.contpointfeature = this.featurecollection.createFeature();
            this.contpointfeature.geometry = this.pointfeature.createGeometry(GEOMETRYTYPE.POINT);
        }
    }
    /**
     * internal function - to activate tool call .enable
     * @method _enableTool
     * @protected
     */
    _enableTool() {
        this.enabled = true;
        this._SubscribeEvents();
        if (this.options.modifycursor) {
            this.scene.getCursorStyleHandler().setCursorStyle(this.options.activecursor);
        }
        this.fire(DrawPointTool.enabled, this.options["cbobject"]);
    }
    /**
     * internal function - to disable tool call .disable
     * @method _disableTool
     * @protected
     */
    _disableTool() {
        this.enabled = false;
        this._cleanUp();
        this.reset();
        if (this.options.modifycursor) {
            this.scene.getCursorStyleHandler().setCursorStyle("default");
            this.scene.getMeasureModeHandler().hideMeasureModeCursor();
        }
        this.fire(DrawPointTool.disabled, this.options["cbobject"]);
        this._unSubscribeEvents();
    }
    _SubscribeEvents() {
        //check if tool is enabled and events aren't already subscribed
        if (!this.enabled || this.mouseupeventnr != null)
            return;
        this.mouseupeventnr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.MOUSEUP, this._onMouseUp, this);
        this.doubletapeventnr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.DOUBLETAP, this._onDoubletap, this);
        if (this.options.resetinput) {
            this.resetinputevent = this.scene.userInputHandler.subscribeEvent(this.options.resetinput, this.reset, this);
        }
        if (this.options.finishinput) {
            this.finishinputevent = this.scene.userInputHandler.subscribeEvent(this.options.finishinput, this._finishmeasurement, this);
        }
        this.mousemoveeventnr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.MOUSEMOVE, this._onMouseMove, this);
        this.mouseouteventnr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.MOUSEOUT, this._onMouseOut, this);
        if (this.options.enablecbf != null) {
            this.on(DrawPointTool.enabled, this.options.enablecbf);
        }
        if (this.options.disablecbf != null) {
            this.on(DrawPointTool.disabled, this.options.disablecbf);
        }
        if (this.options.continousdrawcbf != null) {
            this.on(DrawPointTool.continousdraw, this.options.continousdrawcbf);
        }
        if (this.options.resetcbf != null) {
            this.on(DrawPointTool.reset, this.options.resetcbf);
        }
        if (this.options.finishedcbf != null) {
            this.on(DrawPointTool.finished, this.options.finishedcbf);
        }
    }
    _unSubscribeEvents() {
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.MOUSEUP, this.mouseupeventnr);
        this.mouseupeventnr = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.MOUSEMOVE, this.mousemoveeventnr);
        this.mousemoveeventnr = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.MOUSEOUT, this.mouseouteventnr);
        this.mouseouteventnr = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.DOUBLETAP, this.doubletapeventnr);
        this.doubletapeventnr = null;
        this.scene.userInputHandler.unSubscribeEvent(this.options.resetinput, this.resetinputevent);
        this.resetinputevent = null;
        this.scene.userInputHandler.unSubscribeEvent(this.options.finishinput, this.finishinputevent);
        this.scene.getMeasureModeHandler().hideMeasureModeCursor();
        this.finishinputevent = null;
        if (this.options.enablecbf != null) {
            this.off(DrawPointTool.enabled, this.options.enablecbf);
        }
        if (this.options.disablecbf != null) {
            this.off(DrawPointTool.disabled, this.options.disablecbf);
        }
        if (this.options.continousdrawcbf != null) {
            this.off(DrawPointTool.continousdraw, this.options.continousdrawcbf);
        }
        if (this.options.resetcbf != null) {
            this.off(DrawPointTool.reset, this.options.resetcbf);
        }
        if (this.options.finishedcbf != null) {
            this.off(DrawPointTool.finished, this.options.finishedcbf);
        }
    }
    /**
     * The doubletap event.
     * @method _onDoubletap
     * @param evt
     * @private
     */
    _onDoubletap(evt) {
        this.reset(evt);
    }
    /**
     * internal function mousemove
     * @method _onMouseMove
     * @param evt
     * @private
     */
    _onMouseMove(evt) {
        if (this.contpointfeature.ishidden) {
            this.contpointfeature.show();
        }
        this._measureOnMouseMove(evt);
    }
    /**
     * internal function mouseout
     * @method _onMouseOut
     * @param evt
     * @private
     */
    _onMouseOut(evt) {
        this.contpointfeature.hide();
        this.contpointfeature.update(true);
    }
    /**
     * Mouse up event
     * @method _onMouseUp
     * @param evt
     * @private
     */
    _onMouseUp(evt) {
        if (evt.button == 0) {
            if (evt.isDragging && this.options.continousdraw) {
                this._measureOnMouseMove(evt);
            }
            else if (evt.isDragging) {
                return;
            }
            else {
                this._finishmeasurement(evt);
            }
            return;
        }
        else if (evt.button == 1) {
            //mouse wheel
            return;
        }
        this.reset();
    }
    /**
     * calculates the world coordinate and displays it as point in scene
     * @method _measureOnMouseMove
     * @param evt
     * @private
     */
    _measureOnMouseMove(evt) {
        const mx = evt.offsetX;
        const my = evt.offsetY;
        if (this.scene.getMeasureModeHandler().overrideMeasureMode != null) {
            if (this.options.modifycursor) {
                this.scene.getCursorStyleHandler().setCursorStyle(this.options.activecursor);
                this.scene.getMeasureModeHandler().hideMeasureModeCursor();
            }
            return;
        }
        const mousemovemeasuremode = this.scene.getMeasureModeHandler().mouseMoveMeasureMode;
        if (mousemovemeasuremode == MEASUREMODE.NONE) {
            if (this.options.modifycursor) {
                this.scene.getCursorStyleHandler().setCursorStyle(this.options.activecursor);
                this.scene.getMeasureModeHandler().hideMeasureModeCursor();
            }
            return;
        }
        this._checkSnaping(evt);
        if (this.snappedpos && this.snappedpos.isValid()) {
            this.contpointfeature.geometry.coordinates = [[this.pos.Easting, this.pos.Northing, this.pos.Height]];
            this.contpointfeature.update(true);
            return;
        }
        //make a measurepoint in mousemove measuremode
        if (this.pointpending)
            return;
        this.pointpending = true;
        this.scene.getMeasureHandler().createMeasurePointInMeasureMode(this.scene.getCurrentGeoframe(), mx, my, this.options.maxdist, (pos) => {
            this.pointpending = false;
            if (!this.enabled)
                return;
            this.pos = pos;
            if (this.options.modifycursor) {
                this.scene.getCursorStyleHandler().setCursorStyle(this.options.activecursor);
                this.scene.getMeasureModeHandler().hideMeasureModeCursor();
            }
            if (this.pos && this.pos.isValid()) {
                this.contpointfeature.geometry.coordinates = [
                    [this.pos.Easting, this.pos.Northing, this.pos.Height],
                ];
                this.contpointfeature.update(true);
            }
            this.fire(DrawPointTool.continousdraw, this.options["cbobject"], {
                mx: mx,
                my: my,
                pos: this.pos,
                pointfeature: this.contpointfeature.toGeoJSON(),
            }, evt);
        }, (msg) => {
            this.pointpending = false;
            if (!this.enabled)
                return;
            if (this.scene.getMeasureMode() == MEASUREMODE.PANODEPTHMAPINTERSECTION_MULTIVIEW_COMBINED ||
                this.scene.getMeasureMode() == MEASUREMODE.PANODEPTHMAPINTERSECTION_PANO_TWO_CLICK_COMBINED) {
                this.scene.getMeasureModeHandler().showMeasureModeCursor();
            }
            else if (this.options.modifycursor) {
                this.scene.getCursorStyleHandler().setCursorStyle("not-allowed");
            }
            this.contpointfeature.geometry.coordinates = [[0, 0, 0]];
            this.contpointfeature.update(true);
        }, mousemovemeasuremode);
    }
    _checkSnaping(evt) {
        const mx = evt.offsetX;
        const my = evt.offsetY;
        if (this.options.snaplayer && !evt.altKey) {
            const snapdataarray = this.scene.getFeatureHandler().snap(mx, my, this.options.snaplayer);
            //prevent self pickcing and filter non-pointy geometries
            for (let i = snapdataarray.length - 1; i >= 0; i--) {
                if (snapdataarray[i].geometry.type != GEOMETRYTYPE.MULTIPOINT &&
                    snapdataarray[i].geometry.type != GEOMETRYTYPE.POINT) {
                    snapdataarray.splice(i, 1);
                }
            }
            if (snapdataarray.length > 0) {
                const snapdata = snapdataarray[0];
                this.snap_mx = snapdata.found_mx;
                this.snap_my = snapdata.found_my;
                this.pos.Easting = snapdata.found_easting;
                this.pos.Northing = snapdata.found_northing;
                this.pos.Height = snapdata.found_height;
                this.pos.warning = false;
                this.snappedpos = this.pos;
            }
            else {
                this.snap_mx = null;
                this.snap_my = null;
                this.snappedpos = null;
            }
        }
    }
    /**
     * calcs the world coordinates and the user defined callback functions
     * @method _finishmeasurement
     * @param evt
     * @private
     */
    _finishmeasurement(evt) {
        const mx = evt.offsetX;
        const my = evt.offsetY;
        this.evt = evt;
        if (this.options.continousdraw) {
            this.contpointfeature.geometry.coordinates = [[0, 0, 0]];
            this.contpointfeature.update(true);
        }
        const measuremode = this.scene.getMeasureMode();
        if (measuremode == MEASUREMODE.LEFTRIGHT) {
            if (this.scene.getCurrentGeoFrameCollection().activeimage == "right") {
                this.scene.getCurrentGeoFrameCollection().showLeftImage();
                return;
            }
        }
        if (this.snappedpos == null) {
            this.scene.getMeasureHandler().createMeasurePointInMeasureMode(this.scene.getCurrentGeoframe(), mx, my, this.options.maxdist, (pos) => {
                this._posRequestSuccess(pos);
            }, (pos) => {
                this._posRequestFailed(pos);
            }, measuremode);
        }
        else {
            this._posRequestSuccess(this.snappedpos);
        }
    }
    _posRequestFailed(pos) {
        this.reset();
        this.scene.getMeasureHandler().abortMeasureSequence();
    }
    _posRequestSuccess(pos) {
        if (pos.isValid())
            this._draw(pos);
        //call the user defined event handler...
        if (this.pointfeature.geometry.coordinates.length != 0) {
            const pointfeature = this.pointfeature.toGeoJSON();
            this.fire(DrawPointTool.finished, this.options["cbobject"], {
                pointfeature: pointfeature,
                mx: pos.mouseX,
                my: pos.mouseY,
                measurepoint: pos,
            }, this.evt);
        }
        this.evt = null;
    }
    _draw(coors) {
        this.pointfeature.geometry.coordinates = [[coors.Easting, coors.Northing, coors.Height]];
        this.pointfeature.update(true);
    }
    /**
     * removes all drawing from the scene
     * @method _cleanUp
     * @private
     */
    _cleanUp() {
        this.scene.getMeasureHandler().abortMeasureSequence();
        this.pointfeature.geometry.clear();
        this.pointfeature.update(true);
        this.pointpending = false;
        if (this.options.continousdraw) {
            this.contpointfeature.geometry.clear();
            this.contpointfeature.update(true);
        }
    }
    /**
     *  resets the tool and calls the aborted event
     *  @method reset
     *  @param {?Object} evt EventObject if called from userinput
     *  @public
     */
    reset(evt) {
        this._cleanUp();
        this.fire(DrawPointTool.reset, this.options["cbobject"], evt);
    }
    destroy() {
        this._cleanUp();
        this.featurecollection.destroy();
        this.featurecollection = null;
    }
}
DrawPointTool.enabled = "enabled";
DrawPointTool.disabled = "disabled";
DrawPointTool.continousdraw = "continousdraw";
DrawPointTool.reset = "reset";
DrawPointTool.finished = "finished";
//# sourceMappingURL=drawpointtool.js.map